import { render, staticRenderFns } from "./EditSupplierForm.vue?vue&type=template&id=45c1c870&scoped=true&"
import script from "./EditSupplierForm.vue?vue&type=script&lang=js&"
export * from "./EditSupplierForm.vue?vue&type=script&lang=js&"
import style0 from "./EditSupplierForm.vue?vue&type=style&index=0&id=45c1c870&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c1c870",
  null
  
)

export default component.exports